import produce, { Draft } from 'immer';
import { Reducer } from 'redux';
import { REQUEST_STATUS } from '@common-types/api';
import { ApiCheckoutError } from '@common/Checkout/shared/types';
import {
    RECEIVE_THANK_YOU_DATA,
    RESET_NPS,
    SET_NPS_DATA,
    SET_NPS_SCORE,
    SET_NPS_STATUS,
    SET_THANK_YOU_ERROR,
    UPDATE_NPS_FORM_DATA,
} from '@common/Checkout/ThankYou/actions/constants';
import { TYData, TYNPSRating } from '@common/Checkout/ThankYou/types';
import { TYActions } from '@common/Checkout/ThankYou/types/actions';

interface ThankYouPageState {
    error: ApiCheckoutError | null;
    data: TYData | null;
    nps: TYNPSRating;
}

const initialNPSState = {
    status: REQUEST_STATUS.idle,
    score: null,
    formData: {
        comment: '',
    },
};

const initialState: ThankYouPageState = {
    error: null,
    data: null,
    nps: initialNPSState,
};

const ThankYouPageReducer: Reducer<ThankYouPageState, TYActions> = produce(
    (state: Draft<ThankYouPageState>, action: TYActions) => {
        const { type } = action;

        switch (type) {
            case RECEIVE_THANK_YOU_DATA: {
                const { payload } = action;

                state.data = payload;
                break;
            }

            case SET_THANK_YOU_ERROR: {
                const { payload } = action;

                state.error = payload;
                break;
            }

            case SET_NPS_DATA: {
                const { payload } = action;

                state.nps = payload;
                break;
            }

            case SET_NPS_SCORE: {
                const { payload } = action;

                state.nps.score = payload;
                break;
            }

            case SET_NPS_STATUS: {
                const { payload } = action;

                state.nps.status = payload;
                break;
            }

            case UPDATE_NPS_FORM_DATA: {
                const { payload } = action;

                state.nps.formData = { ...state.nps.formData, ...payload };
                break;
            }

            case RESET_NPS: {
                state.nps = initialNPSState;
                break;
            }

        // skip default
        }
    }, initialState,
);

export default ThankYouPageReducer;
